var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"pt-4",attrs:{"cols":"12"}},[_c('p',[_vm._v("Copyright © "+_vm._s(_vm.year)+" - Todos os direitos reservados. PEJA.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }